module.exports = __webpack_public_path__ + "static/media/135U1_Kitchen.cf815c33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/GalleryPhotos/135U1_Kitchen.jpg
// module id = 537
// module chunks = 0